<template>
  <BaseTableView :head="tableHead" list-view="lgAndUp">
    <WorkDocsWorkAreaTableItem v-for="item in items" :key="item.id" :item="item" />
  </BaseTableView>
</template>

<script>
import WorkDocsWorkAreaTableItem from 'components/setting/workDocsWorkArea/WorkDocsWorkAreaTableItem'
export default {
  name: 'WorkDocsWorkAreaTable',
  props: ['items'],
  components: { WorkDocsWorkAreaTableItem },
  data() {
    return {}
  },
  computed: {
    SettingWorkDocsWorkArea() {
      return this.$route.name === 'SettingWorkDocsWorkArea'
    },
    tableHead() {
      return [
        {
          text: this.SettingWorkDocsWorkArea
            ? this.localStorage.translations.pages['setting-work_area']['tables'][
                'nazvanie-proekta'
              ]
            : this.localStorage.translations.pages['setting-work_area']['tables']['zona-raboty'],
          sort: {
            name: 'name',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'name'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {text: '', active: true},
      ]
    },
  },
}
</script>
